import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { GymConvenience } from '@models';
import { GymService } from '@services';
import { ResolveResult } from './type-resolve-bundle';

@Injectable()
export class GymCommoditiesResolveGuard implements Resolve<GymConvenience[]> {

  constructor(
    private readonly gymService: GymService,
  ) {}

  resolve(): ResolveResult<GymConvenience[]> {
    return this.gymService.getCommotidies();
  }
}
